import React, { useContext, useEffect } from "react";
import {
  BsPersonBoundingBox,
  BsChevronRight,
  BsCheckCircleFill,
} from "react-icons/bs";
import "../../../../assets/css/components/aiContent/AvatarSection.css";
import AppContext from "../../../../context/AppContext";

const AvatarCard = ({ item, selectedAvatar, setSelectedAvatar }) => {
  const isSelected = selectedAvatar?.id === item.id;

  const handleSelect = () => {
    console.log("Avatar Clicked:", item);
    setSelectedAvatar(item);
  };

  return (
    <div
      className={`es-mini-card es-avatar-mini-card ${isSelected ? "selected-card" : ""}`}
      onClick={handleSelect}
    >
      <div className="es-mini-thumb es-avatar-thumb">
        <img
          src={item.preview_image_url}
          alt={item.name}
          className="es-avatar-image"
        />
        {isSelected && (
          <span className="es-avatar-selected-badge">
            <BsCheckCircleFill />
          </span>
        )}
      </div>

      <div className="es-mini-info">
        <p className="es-mini-name">{item.name}</p>
      </div>
    </div>
  );
};

const AvatarSection = ({ items = [] }) => {
  const { selectedAvatar, setSelectedAvatar } = useContext(AppContext);

  useEffect(() => {
    console.log("Avatar Array:", items);
  }, [items]);

  useEffect(() => {
    console.log("Selected Avatar:", selectedAvatar);
  }, [selectedAvatar]);

  return (
    <div className="es-section-block es-avatar-block">
      <div className="es-section-header">
        <div className="es-section-title-group">
          <span className="es-section-icon-wrap es-icon-wrap-avatar">
            <BsPersonBoundingBox />
          </span>

          <div>
            <h4 className="es-section-title">Avatar</h4>
            <p className="es-section-desc">
              Manage AI avatars for your video content.
            </p>
          </div>
        </div>

        <BsChevronRight className="es-section-chevron" />
      </div>

      <AvatarCard
        key={items.id}
        item={items}
        selectedAvatar={selectedAvatar}
        setSelectedAvatar={setSelectedAvatar}
      />

      {items.length === 0 ? (
        <div className="es-empty-state">No Avatar Found</div>
      ) : (
        <div className="es-avatar-grid">
          {/* {items.map((item) => (
            <AvatarCard
              key={item.id}
              item={item}
              selectedAvatar={selectedAvatar}
              setSelectedAvatar={setSelectedAvatar}
            />
          ))} */}
        </div>
      )}
    </div>
  );
};

export default AvatarSection;
